import React from 'react';
import type { IconProps } from '../interfaces/Icon';

/**
 * A FontAwesome icon definition drawn as a plain inline <svg> — the icon pack stays
 * (`@fortawesome/free-solid-svg-icons`, tree-shaken to the icons used), the FontAwesome
 * runtime does not: `fontawesome-svg-core` plus `react-fontawesome` were 19 kB gzip in the
 * entry chunk for four icons (improvement row I2). Decorative by contract — the control that
 * carries the icon names itself (`aria-label` on a button, or visible text beside it).
 *
 * The inline style is FontAwesome's own `.svg-inline--fa` rule set, so the box is the same:
 * `display: var(--fa-display, inline-block); height: 1em; overflow: visible;
 * vertical-align: -0.125em; box-sizing: content-box`, and for `2xl` `font-size: 2em;
 * line-height: 0.03125em; vertical-align: -0.3125em` (the `.svg-inline--fa.fa-2xl` value
 * wins over `.fa-2xl`'s). Width follows the viewBox ratio, as it did before.
 */
export function Icon({ icon, size, color, className }: IconProps) {
    const [width, height, , , path] = icon.icon;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} aria-hidden="true" focusable="false"
             className={className} data-icon={icon.iconName}
             style={{
                 display: 'var(--fa-display, inline-block)', height: '1em', overflow: 'visible', verticalAlign: '-0.125em',
                 boxSizing: 'content-box', color,
                 ...(size === '2xl' ? { fontSize: '2em', lineHeight: '0.03125em', verticalAlign: '-0.3125em' } : {}),
             }}>
            <path fill="currentColor" d={Array.isArray(path) ? path.join(' ') : path}/>
        </svg>
    );
}
